import ActionPanel from '@/components/ActionPanel';
import PageContent from '@/components/PageContent';
import { AchievementTypeEnum, UpsertAchievement, UpsertCityDistrictAchievementType } from '@/models/achievement.model';
import { CityDistrict } from '@/models/city-district.model';
import { City } from '@/models/city.model';
import { BaseErrorModel, BaseResponseModel } from '@/models/core.model';
import { upsertAchievement } from '@/services/achievement.service';
import { toastErrorMessage, toastSuccessMessage } from '@/utils/toasterMessage';
import { AxiosError } from 'axios';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Message, PanelGroup, useToaster } from 'rsuite';



interface CityDistrictActionsProps{
    city?: City;
    formObject?: CityDistrict;
    fetchData: () => void;
};

const CityDistrictActions: React.FC<CityDistrictActionsProps> = ({formObject, city, fetchData}) => {
  const [loadingCreateAchievement, setLoadingCreateAchievement] = useState(false);

  const nav = useNavigate();
  const toaster = useToaster();

  const handleClickCreateAchievement = () => {
    if(!formObject) return;

    const handleYesClick = async () => {
      setLoadingCreateAchievement(true);
      try {
        const model : UpsertAchievement & UpsertCityDistrictAchievementType = {
          name: formObject.name,
          type: AchievementTypeEnum.District,
          supportingCityId: formObject.cityId,
          supportingCountryId: city?.country?.id,
          districtId: formObject.id,
        };
        const result: BaseResponseModel<null> = await upsertAchievement(model);
        if (result.success) {
          toastSuccessMessage(`Achievement Successfully Created.`);
          fetchData();
        }
      } catch (err) {
        const errorModel = (err as AxiosError<BaseErrorModel>).response?.data;
        toastErrorMessage(`Error in creating Achievement:${errorModel?.errorMessage}`);
      }
      finally {
        setLoadingCreateAchievement(false);
        toaster.clear(); 
      }
    };

    const handleNoClick = () => {
      toaster.clear(); 
    };

    toaster.push(
      <Message type="info" closable>
        <p style={{marginBottom:10}}>Are you sure you want to <strong>Create Achievement</strong>?</p>
        <div>
          <Button appearance="primary" onClick={handleYesClick}>Yes</Button>
          <Button appearance="subtle" onClick={handleNoClick} style={{ marginLeft:10}}>No</Button>
        </div>
      </Message>,
      { placement: 'topCenter', duration: 0 }
    );

  };


    return (
        <PageContent>
            <PanelGroup>
                <ActionPanel
                  title='Create Achievement'
                  description='This action let create a new achievement for current city district, if not already created.'
                  onClick={handleClickCreateAchievement}
                  loading={loadingCreateAchievement}
                  disabled={formObject?.hasAchievement}
                />
            </PanelGroup>
        </PageContent>
    );
};

export default CityDistrictActions;
